import { render, staticRenderFns } from "./WorksManagement.vue?vue&type=template&id=76e23c27&scoped=true"
import script from "./WorksManagement.vue?vue&type=script&lang=js"
export * from "./WorksManagement.vue?vue&type=script&lang=js"
import style0 from "./WorksManagement.vue?vue&type=style&index=0&id=76e23c27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e23c27",
  null
  
)

export default component.exports